import React, { memo, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import Slider from "react-slick";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
      >
        <path
          d="M21 15L9 15M15.75 20.25L21 15L15.75 9.75"
          stroke="#111111"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle opacity="0.7" cx="15" cy="15" r="14.5" stroke="black" />
      </svg>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
      >
        <path
          d="M21 15L9 15M15.75 20.25L21 15L15.75 9.75"
          stroke="#111111"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle opacity="0.7" cx="15" cy="15" r="14.5" stroke="black" />
      </svg>
    </div>
  );
}

export default memo( function BrowseByCategory(props) {
  const artgenpage = props.data
  const settings = {
    dots: false,
    infinite: false,
    autoplay: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1169,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const [catState, setCatSate] = useState()
  const [name, setName] = useState('Traditional Art')

  useEffect(() => {
    const stateMap = {
      "Traditional Art": { ActiveArtClass: true },
      "Landscape": { ActiveLandscapeClass: true },
      "Still Life": { ActiveStillLifeClass: true },
      "Photography": { ActivePhotographyClass: true },
      "Abstract": { ActiveAbstractClass: true },
      "Wildlife": { ActiveWildlifeClass: true }
    };
    setCatSate(stateMap[name] || stateMap[""]);
  }, [name]);

  const sendDataToParent = (name, id) => {
    // const dataToSend = name;
    setName(name)
    props.handleEventFromChild1(name, id);
  };

  return (
    <section className={"upcoming-section browseCategory " + (artgenpage === 'artgenre' ? 'artgenrebgnone' : '')}>
      <Container>
        <Row>
          <Col lg={12}>
            <div className={"DigitalArtcollection-head currentauction-head  align-items-baseline " + (artgenpage !== 'artgenre' ? 'justify-content-between d-none' : 'justify-content-start d-flex')}>
              <div className={artgenpage !== 'artgenre' ? '' : 'text-start'}>
                <h2>Category </h2>
                <p>Explore The Artworks In The Most Featured Categories</p>
              </div>
              {artgenpage !== 'artgenre' &&
                <NavLink to={'/art-genres'} className="viewText">View all</NavLink>}


            </div>

            <div className={"categoryBox mt-4 " + (artgenpage ? 'artgenre' : '')}  >
              <div className={catState?.ActiveArtClass === true ? "Boxin1 art active" : "Boxin1 art"} onClick={() => sendDataToParent("Traditional Art", "63a3f8ca3afc27eac9e49068")}>
                <div className="contBox">
                  <div className="imgBox"><img src={"images/svg/cate_art.svg"} alt=""></img></div>
                  <h3 >Traditional Art</h3>
                </div>
              </div>
              {/* <div className={catState?.ActiveLandscapeClass === true ? "Boxin1 landscape active" : "Boxin1 landscape"} onClick={() => sendDataToParent("Landscape", "63a3f8e13afc27eac9e4906f")}>
                <div className="contBox">
                  <div className="imgBox"><img src={"images/svg/cate_landscape.svg"} alt=""></img></div>
                  <h3 >Landscape</h3>
                </div>
              </div> */}
              {/* <div className={catState?.ActiveStillLifeClass === true ? "Boxin1 sport active" : "Boxin1 sport"} onClick={() => sendDataToParent("Still Life", "6540f43445002d8e6474c2e8")} >
                <div className="contBox">
                  <div className="imgBox"><img src={"images/png/stilllife.png"} alt=""></img></div>
                  <h3>Still Life</h3>
                </div>
              </div> */}
              <div className={catState?.ActivePhotographyClass === true ? "Boxin1 cryptopunks active" : "Boxin1 cryptopunks"} onClick={() => sendDataToParent("Photography", "64ed723878520f06b3c4bbc0")} >
                <div className="contBox">
                  <div className="imgBox"><img src={"images/svg/camera.svg"} alt=""></img></div>
                  <h3>Photography </h3>
                </div>
              </div>
              {/* <div className={catState?.ActiveAbstractClass === true ? "Boxin1 cubism active" : "Boxin1 cubism"} onClick={() => sendDataToParent("Abstract", "63a402173afc27eac9e490cf")} >
                <div className="contBox">
                  <div className="imgBox"><img src={"images/svg/cate_cubism.svg"} alt=""></img></div>
                  <h3>Abstract</h3>
                </div>
              </div>

              <div className={catState?.ActiveWildlifeClass === true ? "Boxin1 utility active" : "Boxin1 utility"} onClick={() => sendDataToParent("Wildlife", "63a4023a3afc27eac9e490d6")} >
                <div className="contBox">
                  <div className="imgBox"><img src={"images/svg/wildlife.svg"} alt=""></img></div>
                  <h3 >Wildlife </h3>
                </div>
            </div> */}
            </div>
          </Col>
        </Row>

        {/* <div className="currenta-auction-slider">
          <Slider {...settings}>
            {categories &&
              categories?.length > 0 &&
              categories.map((item, idx) => {
                return (
                  <div key={idx}>
                    <div className="digital-art-wrap upcomimg-aution">
                      <Link to={`/shop?value=${item?._id}`}>
                        <div className="currentlive-art-img position-relative">
                          <img
                            src={
                              item?.image?.link || "images/Currentlive01.png"
                            }
                            alt=""
                            className="img-fluid home-cate"
                          />
                        </div>
                      </Link>
                      <div className="upcomimg-art-content">
                        <div className="user-partwrap">
                          <div className="user-part">
                            <h3>{item?.name}</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </Slider>
        </div> */}
      </Container>
    </section>
  );
})
